import { cn } from '@/true-fsd/shared/utils/css'
import {
    Popover,
    PopoverArrow,
    PopoverContent,
    PopoverTrigger,
} from '@/shared/ui/popover'
import { Slot } from '@radix-ui/react-slot'
import { CSSProperties, HTMLAttributes, ReactNode } from 'react'

type DisableTooltipProps = {
    children: ReactNode
    message: ReactNode
    enabled: boolean
    asChild?: boolean
    contentStyle?: CSSProperties
} & HTMLAttributes<HTMLDivElement>

export const DisableTooltip: React.FC<DisableTooltipProps> = ({
    children,
    message: messageProp,
    enabled,
    className,
    style,
    asChild = false,
    contentStyle,
    ...props
}) => {
    const Comp = asChild ? Slot : 'div'

    let message: ReactNode = messageProp
    if (typeof messageProp === 'string') {
        message = <p>{messageProp}</p>
    }

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Comp
                    style={{
                        cursor: enabled ? 'pointer' : 'default',
                        ...style,
                    }}
                    className={cn('', className)}
                    {...props}
                >
                    {children}
                </Comp>
            </PopoverTrigger>
            {enabled && (
                <PopoverContent
                    style={contentStyle}
                    className="relative w-[161px] text-pretty border p-2 text-center text-[10px] leading-[14px] shadow-md"
                    side="top"
                >
                    {message}
                    <PopoverArrow
                        className="fill-white drop-shadow-[0_1px_0_#e9e9ed]"
                        width={15}
                        height={9}
                    />
                </PopoverContent>
            )}
        </Popover>
    )
}

export const ClickTooltip = DisableTooltip
export type ClickTooltipProps = DisableTooltipProps
